import React from 'react';

import { CYLINDER_WARP } from 'src/models/documentWarps';
import CylinderWarp from './cylinder';
import NPointWarp from './nPoint';

type WarpProps = {
    selected: boolean;
    documentId: string;
    warpType: string;
    scale: number;
    cursorChange: (cursor: string) => void;
    offset: {
        x: number;
        y: number;
    };
    container: HTMLElement;
};

const Warp: React.FC<WarpProps> = ({ scale, offset, cursorChange, container, documentId, warpType, selected }) => {
    const RenderedWarp = warpType === CYLINDER_WARP ? CylinderWarp : NPointWarp;
    return (
        <RenderedWarp
            selected={selected}
            documentId={documentId}
            container={container}
            cursorChange={cursorChange}
            scale={scale}
            offset={offset}
        />
    );
};

export default React.memo(Warp);
